import styled, { keyframes } from 'styled-components';
import React from "react";
import {Icon} from 'semantic-ui-react'
import Chart from "react-apexcharts";

const Component2 = () =>{

    return (
        <Container>

            <T1>The probability of improving your culture goes up by <strong>over 8x.</strong></T1>
            <Text>
                Based on the thousands of teams we've worked with. Teams that followed a data journey were significantly more successful in improving their culture.
            </Text>

            <Row>
                <ChartContainer delay={0.5}>
                <Chart
                            options={data3.options}
                            series={data3.series}
                            type="bar"
                            height={250}
                        />
                </ChartContainer>
            </Row>

            <SmallText delay={1}>
                *Based on a study of 1000+ teams
            </SmallText>
            <SmallText delay={1}>
                *Improvements measured as % of overall score
            </SmallText>
           

         
        </Container>
    )
}

export default Component2

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
    font-family:'Raleway';
    padding-top:20px;
    padding-bottom:150px;
    `

const Text = styled.div`
    font-size:16px;
    color:#2A3039;
    margin-bottom:10px;
    margin-top:10px;
    display:flex;
    align-items:center;
    justify-content:space-between;
    opacity:0;
    line-height:1.5;
    max-width:500px;

    animation: ${fadeIn} 1s ease-out forwards;
`

const ChartContainer = styled.div`
    width:400px;
   
    margin-top:40px;

    opacity:0;

    animation: ${fadeIn} 1s ease-out forwards;
   animation-delay: ${({ delay }) => delay}s; // Use props to set delay
`

const Title = styled.div`
    font-size:16px;
    font-weight:600;
    margin-bottom:10px;
`

const T2 = styled.div`
    font-size:16px;
    color:#2A3039;
`

const T1 = styled.div`
    font-size:24px;
    font-weight:600;
    margin-bottom:20px;
    margin-top:10px;
    max-width:600px;
    line-height:1.5;
`

const IconContainer = styled.div`
    width:30px;
    height:30px;
    background-color:#2A3039;
    color:white;
    border-radius:50%;
    display:flex;
    justify-content:center;
    align-items:center;
    margin-right:20px;
    min-width:30px;
`
const Row = styled.div`
    display:flex;
    width:100%;
    align-items:center;
    justify-content:center;
`

const SmallText = styled.div`
    font-size:12px;
    opacity:0;

    animation: ${fadeIn} 1s ease-out forwards;
   animation-delay: ${({ delay }) => delay}s; // Use props to set delay
`

const data3 = {
	series: [
		{
			data: [0.75, 8],
		},
	],
	options: {
		chart: {
			type: "bar",
			fontFamily:"Poppins, sans-serif",
			foreColor: '#7E7E7E',
			toolbar: {
				show: false,
			},
			width: 400,
			height: 400,
		},
		legend: {
			position: "top",
			horizontalAlign: "left",
            show: false
		},
        grid:{
            show:false
        },
        plotOptions: {
            bar: {
              columnWidth: '75px',
              distributed: true,
            }
          },
		colors: ["#F15062","#2D70E2", "#27CDA7", "#C0C0C0"],
		xaxis: {
			categories: [
				"Without data journey",
                "With data journey"
			],
			tickPlacement: "between",
			labels:{
				style:{
					fontSize:'9px',
                    colors: ["#F15062","#2D70E2", "#27CDA7", "#C0C0C0"],
				}
			}
		},
		yaxis: {
            show:false,
			min: 0,
			max: 8.5,
			decimalsInFloat: 1,
            axisTicks:{
                show:false
            },
			title: {
				text: "Psychological Safety Scores",
				style:{
					fontWeight:400
				}
			},
		},
	},
};
